import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import previewStakeRewards, { PreviewStakeRewardsInput, PreviewStakeRewardsOutput } from '.';

type TrimmedPreviewStakeRewardsInput = Omit<PreviewStakeRewardsInput, 'dlVaultContract'>;

export type UsePreviewStakeRewardsQueryKey = [
  FunctionKey.PREVIEW_STAKE_REWARDS,
  TrimmedPreviewStakeRewardsInput,
];

type Options = QueryObserverOptions<
  PreviewStakeRewardsOutput,
  Error,
  PreviewStakeRewardsOutput,
  PreviewStakeRewardsOutput,
  UsePreviewStakeRewardsQueryKey
>;

const usePreviewStakeRewards = (input: TrimmedPreviewStakeRewardsInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.PREVIEW_STAKE_REWARDS, input],
    () => previewStakeRewards({ dlVaultContract, ...input }),
    options,
  );
};

export default usePreviewStakeRewards; 